var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 68,
    viewBox: "0 0 67 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Social"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.7619 33.8289C19.8285 33.7956 19.8951 33.764 19.9601 33.734C21.0889 33.2112 22.2327 32.7217 23.3749 32.2322C23.4365 32.2322 23.5397 32.1606 23.5979 32.1373C23.6862 32.099 23.7744 32.0624 23.8627 32.0241C24.0325 31.9508 24.2023 31.8792 24.3705 31.806C24.7102 31.6611 25.0481 31.5162 25.3878 31.3714C26.0654 31.0817 26.743 30.792 27.4207 30.5006C28.7759 29.9212 30.1329 29.3401 31.4882 28.7607C32.8434 28.1813 34.2003 27.6002 35.5556 27.0208C36.9109 26.4413 38.2678 25.8603 39.6231 25.2808C40.9783 24.7014 42.3353 24.1203 43.6906 23.5409C43.9919 23.411 44.3183 23.2179 44.6413 23.1613C44.9126 23.113 45.1773 23.0198 45.4504 22.9682C45.9682 22.8699 46.5393 22.83 47.0354 23.0448C47.2069 23.1197 47.3651 23.2246 47.4966 23.3561C48.126 23.9788 48.0377 25.0011 47.9045 25.8769C46.9772 31.9808 46.0498 38.0863 45.1207 44.1902C44.9942 45.0277 44.821 45.9467 44.1601 46.4762C43.6006 46.9241 42.8048 46.9741 42.1138 46.7843C41.4229 46.5928 40.8135 46.1915 40.2158 45.7969C37.7367 44.1552 35.2559 42.5135 32.7768 40.8719C32.1874 40.4823 31.5315 39.9728 31.5381 39.2651C31.5414 38.8389 31.7962 38.4593 32.0559 38.1213C34.2103 35.3108 37.3188 33.3794 39.6314 30.6987C39.9577 30.3208 40.2141 29.6381 39.7663 29.42C39.4999 29.2902 39.1935 29.4666 38.9504 29.6348C35.8936 31.7577 32.8384 33.8822 29.7816 36.0051C28.7843 36.6977 27.7387 37.4103 26.5366 37.5802C25.461 37.7333 24.3788 37.4336 23.3382 37.1273C22.4658 36.8709 21.595 36.6078 20.7276 36.3364C20.2664 36.1932 19.7902 36.0384 19.4339 35.7137C19.0776 35.389 18.8728 34.8429 19.0876 34.41C19.2225 34.1386 19.4839 33.9671 19.7586 33.8273L19.7619 33.8289Z",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 5",
    cx: 33.5,
    cy: 34.3887,
    r: 33,
    stroke: "#303030"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialTelegram);
export default __webpack_public_path__ + "static/media/social-telegram.f9a02870ab5979e20ce10a29208349153146eaef22c39200e68e42e45b9e0bb3.svg";
export { ForwardRef as ReactComponent };